export default __webpack_public_path__ + "static/media/RadicalSpaces.88fb4236.pdf";